import React, { useState, useEffect } from "react";
import "./Home.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import aboUeducate from "../../Assests_Url/about ueducate.png";
import img1 from "../../Assests_Url/image 1.png";
import img2 from "../../Assests_Url/image 3.png";
import img3 from "../../Assests_Url/image 4.png";
import img4 from "../../Assests_Url/image 5.png";
import { getNcretBookDetails } from "../../Services/ApiService";
import student from "../../Assests_Url/student_kat.png";
import teacher from "../../Assests_Url/teacher_kat.png";
import family from "../../Assests_Url/family_kat.png";
import { useNavigate } from "react-router-dom";

const Home = ({ RoutesClick, NcertClick, Rootsref, Ncertref }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = useState("Home");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState(null);
  const [currentPage, setCurrentPage] = useState(0); // for slider

  const [tabs, setTabs] = useState([]);
  console.log(tabs, "123");

  const getBookData = async () => {
    try {
      let res = await getNcretBookDetails();
      if (res?.success === true) {
        const allowedClasses = ["Class 1", "Class 6", "Class 12"];
        const allowedLanguages = ["english", "hindi"];
        let data = res.data
          .filter(
            (std) =>
              allowedClasses.includes(std.standardName) &&
              allowedLanguages.includes(std.bookLanguage)
          )
          .map((std) => ({
            label: std.standardName,
            value: std.standardId,
            bookName: std.bookName,
            coverImage: std.coverImage,
            crumb: std.crumb,
            url: std.url,
            bookLanguage: std.bookLanguage,
          }));
        setTabs(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classMap = {
    "Class 1": "I Standard",
    "Class 6": "VI Standard",
    "Class 12": "XII Standard",
  };

  const uniqueTabs = [...new Set(tabs.map((t) => t.label))];
  const filteredBooks = tabs.filter((book) => book.label === activeTab);

  const booksPerPage = 4;
  // const totalPages =
  //   filteredBooks.length > booksPerPage ? 2 : 1; // 1 or 2 pages only
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);

  const showArrows = filteredBooks.length > booksPerPage;

  let currentBooks = [];
  if (totalPages === 1) {
    currentBooks = filteredBooks; // 4 or less books
  } else {
    if (currentPage === 0) {
      currentBooks = filteredBooks.slice(0, booksPerPage); // first 4
    } else {
      currentBooks = filteredBooks.slice(-booksPerPage); // last 4
    }
  }

  useEffect(() => {
    if (uniqueTabs.length > 0 && !activeTab) {
      setActiveTab(uniqueTabs[0]);
    }
  }, [uniqueTabs, activeTab]);

  useEffect(() => {
    getBookData();
  }, []);

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
      <div>
        <div>
          {/* <MediaQuery minWidth={700}> */}
          <div className="w-100">
            <div className="newHomeBanner">
              <div className="bannerOverlay">
                <div className="homeban">
                  <div className="d-flex flex-column align-items-center">
                    <div className="homeBan1">
                      <span className="homeban2">Introducing </span>
                      <span className="homeban3">KATBOOKS</span>
                    </div>
                    <div className="homeban1_2">
                      World’s most advanced and interactive format of digital
                      books
                    </div>
                    <div className="homebanNCERT">
                      <span className="homebanNCERT1">
                        Pilot Project in association with NCERT
                      </span>
                    </div>
                    <div className="homebanBooks mt-2">
                      NCERT books are now available in KATBOOK format for
                      classes 1, 6 & 12 (for all subjects)
                    </div>
                    <button
                      className="registerBtn mt-4"
                      onClick={() => {
                        setRegisterModal(!registerModal);
                      }}
                    >
                      Register now &nbsp; &rarr;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </MediaQuery> */}
        </div>

        <div className="secondPotionHome">
          <div className="container">
            <div className="row align-items-start h-100 d-flex justify-content-center align-items-center pad4per">
              {/* Left side - Image */}
              <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
                <img
                  src="https://cdn.katbook.com/assets/sites/ncert/754664531329945600_aboutKatbook.png"
                  className="width_mob aboutKatt"
                  alt="Katbook Device Screenshot"
                />
              </div>

              {/* Right side - Content */}
              <div className="col-md-6 d-flex flex-column justify-content-center">
                <div className="hsFonnt">
                  <span className="hsFonnt1">KATBOOK</span> is next-generation{" "}
                  <span className="hsFonnt2">digital textbook platform</span>,
                  developed with U-Educate to transform the way India learns. It
                  blends{" "}
                  <span className="hsFonnt2">
                    audio, video, 2D/3D/AR/VR models, interactive exercises,
                    translation tools, smart search, personalization, and
                    analytics
                  </span>{" "}
                  into one seamless experience.
                </div>
                <div className="hsFonnt pt-3">
                  Unlike static e-books, KATBOOK offers two tailored experiences
                  —{" "}
                  <span className="hsFonnt2">
                    for Foundation learners (Classes 1–5)
                  </span>{" "}
                  and{" "}
                  <span className="hsFonnt2">
                    Higher Standard learners (Classes 6–12)
                  </span>{" "}
                  —ensuring every stage of education is supported with the right
                  tools.
                </div>

                <div>
                  <button
                    className="registerBtn mt-4"
                    onClick={() => {
                      navigate("/katbook")
                    }}
                  >
                    Read More &nbsp; &rarr;
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-2 pb-4 px-4">
          <div className="compe-font">Why KATBOOK ?</div>
          <div className="d-flex justify-content-center align-items-center gap-5">
            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">For Students</div>
              <div>
                <img src={student} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It makes learning joyful, interactive, and self-paced
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">For Teachers</div>
              <div>
                <img src={teacher} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It provides structured lesson support, multimedia resources, and
                analytics
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">For Parents</div>
              <div>
                <img src={family} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It offers transparency into their child’s learning journey
              </div>
            </div>
          </div>
        </div>

        <div className="hrLine" />

        <div className="py-3 container">
          <div className="d-flex justify-content-center">
            <span className="HoT">About</span>{" "}
            <span className="hot1">U-EDUCATE</span>
          </div>

          <div className="row align-items-start h-100 d-flex justify-content-center align-items-center py-5">
            <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
              <img
                src={aboUeducate}
                className="width_mob abouImgaude"
                alt="Katbook Device Screenshot"
              />
            </div>
            <div className="col-md-6 mb-4 mb-md-0 d-flex flex-column justify-content-center">
              <div className="hot2">U-Educate Global Private Limited -</div>
              <div className="hot3">
                a comprehensive digital education platform that seamlessly
                integrates multiple tools for smart education. With its
                innovative and first of its kind product offering, U-Educate is
                revolutionizing teaching and learning, not just in India but
                across the globe.
              </div>
              <div className="hot3 py-3">
                By uniting interactive content, adaptive learning systems, and
                real-time analytics empowering educators to personalise
                instruction and students to chart their own learning journeys.
              </div>
              <div className="py-3">
                <button className="registerBtn regReadmore wid200px"  onClick={() => {
                      navigate("/ueducate")
                    }}>
                  Read more &nbsp; &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="hof pb-5">
          <div className="container">
            <div className="py-3 d-flex justify-content-center align-items-center gap-2">
              <div className="d-flex flex-column justify-content-center align-items-center paddd25hof">
                <span className="hof1">Our</span>
                <span className="ourunderline" />
              </div>
              <div className="hof2">KATBOOKS</div>
            </div>

            <div className="d-flex justify-content-center mb-4">
              <div className="tab-rounded-group">
                {uniqueTabs.map((label, idx) => (
                  <button
                    key={label}
                    className={`tab-btn ${activeTab === label ? "active" : ""
                      } tabfontsze`}
                    style={{
                      borderTopLeftRadius: idx === 0 ? 24 : 0,
                      borderBottomLeftRadius: idx === 0 ? 24 : 0,
                      borderTopRightRadius:
                        idx === uniqueTabs.length - 1 ? 24 : 0,
                      borderBottomRightRadius:
                        idx === uniqueTabs.length - 1 ? 24 : 0,
                      borderRight:
                        idx !== uniqueTabs.length - 1
                          ? "1.2px solid #2970b5"
                          : "none",
                    }}
                    onClick={() => setActiveTab(label)}
                  >
                    {classMap[label] || label}
                  </button>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              {showArrows && (
                <div onClick={() => setCurrentPage((p) => Math.max(p - 1, 0))}>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQdSURBVHgBxZrBUtRAEIb/sJvNQnnAgwctS9oncG+WJ+IDWOATQJUnL4JHT2x5sfSy6AvAG8ALWODBM/gCAgc9aJXsyapV1jizmSaTsIEk0wlfVTPsJNmdnp6envSMBzlISajkgSnnLWGOjRwa+WQ+Xzu6kX0lR0qiiqKfHSDuiMYJlexlGnSqZEvJmpIlJQtIWwOmbtHcs4OLHaCfJzQAmQbYjR+YxlVFP7uFBhVaR9xwVmADF3vcBTLfaQ+5FQizaf3AHuo1PyFtoQEE0D1+gMQKa2gOewQcwMH6thLazD0IMK/wg+BIS4HbCcmEUFkZWwmCEH6ns9UOgqhVTBHgojKlYJ8QVaLd7faNEt/Q7VKJRwmJMoV9ZhWJTxCE6MzNLWsltMwEwQuUp4fEZ9avupmQaC7m2F3V+9onjDV+YG7uNqqxjoKdzNPeFoRg52ZrtDudt3BDT/+6jTt5NxCSuZsgBDu3UeK0pG9Mg5AMsXDaDWyNDQjBzn0uvi8S3JCsAPayFwjC1rCd28hvVX0LMuh4wlZJxZYBBH3Ddm6Wlu+/hyzc5tQI4plqEY5ccO5YRkq7e5AlRBLrJlC2woWUc7M1guAD6oGH18IMEs8/hCPauSPPW81U/xvHK4U62DVlqBV5YD7swwHt3IiiaTPeR4xGX1EP3Pk9rUgvU1ka7dzReDx9ah2P36A+TkwZ6j/s6AuoQI5zcwD8rG6ZQX0QLP/m+FGJac59Lu228yx4BTqG8NqruiJ+t7uaq0RsjSaYtN/J7FEULeVe9Lw/aBCtyND8X/o10oszhXmE8P2HaBAnZ1fDaJA7vIJgD/VCMM5uW6RScuFsNHqJ/BgUKod/hPogUx7PWI0gVORsdvZplJeMbrVeoT44mB9qRb6YD9XTPcPhcOx5j5X3D6dcfVLDgpEJTTkJ5gRrLnZBrbXCnKn4HeqB/ZuyFSEcUVF+fYoiv5RV7kOWEFZU5ziybcolOPJ3NNpUMaSfqvS8m+0oeg5ZVky5a1faoV4kw97qdLYzltFpoDuQgXDJqzmnWTYggVpMqsYfZJRxTQUxfVzyah5COsOolvetdE7rJ2Zn78INQoFECe9GyUVkpYzOZ1nKvIYbhZKIhBL51aIof7FTQ99x40bVtBCnTAsl1+38qsieiMaeln3ff4byEJJOXin6EOeMCmlelPMFpvKVbgPbCkwtGz16RTyxSkMbPZrs1htBAjUt65ms4I5VDwJbb5OfRXozVGwCKIDYZqgN+wxPe4T6IKRPVUhl8M9ZRfrIRR+yCvG5FvtQgtiuWRbC9OMWIaoTIu71U+s7d9DgmZSsQkemAWumcZR5Zt7ULZt79POnme/QQ2oR1wAh7s0jlDvalO2ADTg6swc5CMnBs575TNb1oSX7iF9PdXkCAf4DGDy4Nf+5q1cAAAAASUVORK5CYII="
                    style={{
                      width: "75%",
                      cursor: currentPage === 0 ? "no-drop" : "pointer",
                      opacity: currentPage === 0 ? "0.2" : "1",
                    }}
                    alt="leftarrow"
                  />
                </div>
              )}

              <div className="bookrowflex">
                {currentBooks.map((book, idx) => (
                  <div className="card tabimagcard">
                    <img
                      src={book.coverImage}
                      className="card-img-top insiImgcard"
                      alt={book.bookName}
                    />
                    <div className="fw-semibold text-center mb-2 cardimgdowtit">
                      {book.bookName}
                    </div>
                    <div className="card-body d-flex flex-column">
                      <button className="btn btn-primary mt-auto subscribebtn"
                        onClick={() => {
                          setRegisterModal(!registerModal);
                        }}>
                        Subscribe
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {showArrows && (
                <div
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages - 1))
                  }
                >
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ8SURBVHgBxZq/c9NIFMe/cqxIZo45F1ddk3c3d3Ml7q6M7i8I5V11DA0VE+APwKajImmgDZRUTkuVUFAnNMwwFAkFM9BgZmiIib28tXej1co2svRkPjObHa9Wyn736b39pQByEKeE0xWTt51kOTXp2KTn5vcPRzeyx+mEkyqZ9L07mHbEykk4HXgNGnDa47TNaYvTBrLWgCnbNHX6yHeAvp+wAsg0wG38jmlcWfS9e1ihoFuYNtwK6CLf41Ug80z3lfsfwuw6/+AA9ZqfkLXQDgTQPX6E1ArbWB3uG3CECtZ3RWgzd7B6CGlAKC3GFUHfqxxG0YlOaLcl/QbIi1kK6xOFRGjWWEQzihSnA8hDSMUU9plrSH2Cit6EOCYW834iJgxFHNSjg9Rnbn2vMiFVvrRjr8XxdWMV1Vxf70EeLaBQJ9uwt4dy/MRWeWPFhHEsPg4gnVH051UgpLGbUBJ2+JuOVQZhGEpHO0L6iiWzKlhrdFGNNov4cGEVDgIx+w9ksTOAXGAhCFjDwpa4f2EVI0Y4LOtnWatknruDar6RJY5/YzEfXTE1hGXb5swbZCPVJoRgp3/oCZEOywnSsW4C+QUSRFH0Fzf+c06MbFi2r9dGA6nnH0OQs7Oz15w9y10Igq5gWN43eaKFXDE/DiHMuVJ3ORv75Wo83hUKy7bzO1pIxyuUYzh8pWYFkCBoo9HoC4TltyZP9B/r6Buogyj6PecncmGZ4Pi3HT9qg+dgT+eJqRiWdSdM5l4NrIAAeLTgclIhLH8y+cSqtVtE04zjFwusUmWCOWm/tkhGVW0oNVx4fTxOUAFXyM+oibDV+htzZqqWsVKHWB4y+akrpL7NhdFo8YpOqd7o69cnWB4y+UTIoVcoCk9V/lRBsLWgyu75cHgP5bCD+XGT/7w0P2qxyDlwh6NWa9Y1pdT+aDi8jfIkJp8M5oR0HSwKW+MPjkiDOZHqSGCNYgdz8gsSCMID4ZNZIvTWEapPTxI4o7odEB+bfAtSXLr0a6DUv34x/+fTURD8gy9fTlENO+7su4UXQz2ExhPu+Qc1WUJDWLA0t9ssXVTl8uVf/EXVGu+oQG5HpYcFS/MEZXYYZ8DTkXs5a6yvX4UMhAIbJfY0qsqMVG/SvfOm65LHEYU2EQlL7K/OohFFN7w1evVXNcVumepIRUUra0HLvtMtbvyrmkQQ0k4uPFO2e0aFlFvWWq3/HGtIbv0QShwrWJY66NHr76bxDXbsPuQgVDjo0fhHb7Socpge9BwJbo92IHD0BuQPQ+cGAD3YCQ54gOBhqIv1GRv2CPVByH5VIX76dQ3ZTy56kBVkv2txP0qQHH8yEGZ/bpGgPAmmvT5wntnHCr9J8QWdmAZsm8aRd0/blF01dfT9A+8Z+pXaxA+AMO3NEyz3aZPfAV1UdOYAchDSD8865jc51z856RDT5anO30KAb6R5yQVQB3/2AAAAAElFTkSuQmCC"
                    alt="rightarrow"
                    style={{
                      width: "75%",
                      cursor:
                        currentPage === totalPages - 1 ? "no-drop" : "pointer",
                      opacity: currentPage === totalPages - 1 ? "0.2" : "1",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
    </div>
  );
};

export default Home;
